function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 10,
  fill: "#FFE0E0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7903 14.5256C27.3553 14.736 27.1733 15.2594 27.3838 15.6941C27.9586 16.8816 28.25 18.1617 28.25 19.5C28.25 24.3247 24.3247 28.25 19.5 28.25C14.6753 28.25 10.75 24.3247 10.75 19.5C10.75 14.6753 14.6753 10.75 19.5 10.75C21.4993 10.75 23.3775 11.4028 24.932 12.6378C25.3091 12.9388 25.8604 12.8758 26.1614 12.4974C26.4624 12.1193 26.3994 11.5686 26.0208 11.268C24.1805 9.80536 21.8646 9 19.5 9C13.7106 9 9 13.7106 9 19.5C9 25.2894 13.7106 30 19.5 30C25.2894 30 30 25.2894 30 19.5C30 17.8957 29.6497 16.3582 28.9588 14.9321C28.7488 14.4963 28.2237 14.3147 27.7903 14.5256Z",
  fill: "#E25141"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.003 14.9182C19.5423 14.9182 19.1699 15.2906 19.1699 15.7513V20.75C19.1699 21.2107 19.5423 21.5831 20.003 21.5831C20.4637 21.5831 20.8361 21.2099 20.8361 20.75V15.7513C20.8361 15.2906 20.4638 14.9182 20.003 14.9182Z",
  fill: "#E25141"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7686 23.8482C20.727 23.7399 20.6687 23.6483 20.5937 23.5733C20.552 23.54 20.5104 23.4983 20.4604 23.4734C20.4188 23.4401 20.3688 23.4159 20.3188 23.3984C20.2688 23.3726 20.2188 23.3567 20.1605 23.3484C19.8947 23.2901 19.6023 23.3825 19.4115 23.5733C19.3365 23.6483 19.2782 23.74 19.2366 23.8482C19.1949 23.9482 19.1699 24.0565 19.1699 24.1648C19.1699 24.2732 19.1949 24.3814 19.2366 24.4814C19.2782 24.5814 19.3365 24.673 19.4115 24.7564C19.4948 24.8313 19.5865 24.8896 19.6864 24.9313C19.7864 24.973 19.8947 24.998 20.003 24.998C20.1113 24.998 20.2188 24.973 20.3188 24.9313C20.4187 24.8897 20.5095 24.8314 20.5937 24.7564C20.6687 24.673 20.727 24.5814 20.7686 24.4814C20.8103 24.3815 20.8353 24.2732 20.8353 24.1648C20.8353 24.0565 20.8103 23.9482 20.7686 23.8482Z",
  fill: "#E25141"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.85476b4b.svg";
export { ForwardRef as ReactComponent };